<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentProfile /> 
</template>
<script>

import HeaderDash from '@/components/manager/dashboard/HeaderDash.vue'
import SideMenu from '@/components/manager/dashboard/SideMenu.vue'
import ContentProfile from '@/components/manager/dashboard/modules/setting/profile/ContentProfile.vue'

export default 
{
  name: 'Manager-Profile',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentProfile
  }
}
</script>
<style>


</style>